<template>
  <div class="pt-5">
    <FileRow
      v-for="(file, idx) in files"
      :key="idx"
      @remove="$emit('remove', idx)"
      :name="file.fileEl.name"
      :size="file.fileEl.size"
      :type="file.fileEl.type"
      :uploading="file.uploading"
      :uploaded="file.uploaded"
      :completed="file.completed"
      :download-url="file.downloadUrl"
    />
  </div>
</template>

<script>
import FileRow from './FileRow.vue'
export default {
  emits: ['remove'],
  components: { FileRow },
  props: {
    files: Array
  }
}
</script>